import config from "./../config/config.json";
import http from "./httpService";
const apiEndpoint = config.apiUrl + "/erinstructions";

function erinstructionUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getERInstructions() {
  return http.get(apiEndpoint);
}

export function getERinstruction(Id) {
  return http.get(erinstructionUrl(Id));
}

export function saveERinstruction(erinstruction, attachments, onUploadProgress) {
  const body = { ...erinstruction };

  if (attachments && attachments.length > 0) {
    const formData = new FormData();
    const config = {
      onUploadProgress: (progressEvent) =>
        onUploadProgress && onUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100)),
    };

    for (let i = 0; i < attachments.length; i++) {
      formData.append("imageSrc", attachments[i]);
    }

    delete body._id;
    const bodyJson = JSON.stringify(body);
    formData.append("erInstruction", bodyJson);

    if (erinstruction._id) {
      return http.put(erinstructionUrl(erinstruction._id), formData, config);
    }
    
    return http.post(apiEndpoint, formData, config);
  } else {
    delete body._id;

    if (erinstruction._id) {
      return http.put(erinstructionUrl(erinstruction._id), body);
    }
    
    return http.post(apiEndpoint, body);
  }
}

export function deleteERinstruction(Id) {
  return http.delete(erinstructionUrl(Id));
}
